import { UserService } from '@nuskin/ns-account';
import { getConfiguration } from '@nuskin/configuration-sdk';
import { ProductDataService } from '@nuskin/ns-product';
import {
  AdrService,
  CartService,
  CurrencyService,
  EquinoxCartService,
  FavoritesService,
  PriceType,
  Product,
  ProductStatusService,
  ShopContextService,
  ProductService
} from '@nuskin/ns-shop';
import {
  ConfigService,
  equinoxLocalStorage,
  events,
  RunConfigService,
  SitesSessionStorageService,
  StringService,
  util,
  dateFormatter
} from '@nuskin/ns-util';
import '@polymer/polymer/lib/elements/dom-if.js';
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import template from './ns-product-small.html';

import '../ns-variant-details/ns-variant-details.js';

// Import Images
import '../img/ic-close-circle-copy-2.png';
import TranslationMixin from '../temp/ns-translations';

const SEARCH_TERM_KEY = "searchResultsData";
const PRODUCT_SMALL_VARIANT = "product-card.selected-variant";  //also used in ns-product-detail
const KEY_BREADCRUMB_BACK = "breadcrumbBack";

/**
 * This is the ns-product-small component. Notice that is has some issues, please fix...
 *
 * <h2>Demo</h2>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-product-small sku="01003610"></ns-product-small>
 *   </template>
 * </demo-snippet>
 */
export class NsProductSmall extends TranslationMixin(PolymerElement) {

  static get is() {
    return "ns-product-small";
  }

  static get template() {
    let htmlElement = document.createElement('TEMPLATE');
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      //Pass in data  =   =   =   =   =
      sku: {
        type: String,
        observer: '_skuUpdate'
      },
      displaySku: {
        type: String
      },
      selectVariantTypeText: {
        type: String,
        reflectToAttribute: true
      },
      theme: {
        type: String,
        value: 'default',
        observer: '_processTheme'
      },
      productData: {
        type: Object,
        observer: '_handleInputProductData'
      },
      pdpurl: String,
      href: String,
      //Display toggles   =   =   =   =
      fullCardLink: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      showSelect: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      showPurchase: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      showFavorite: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      showQty: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      editQty: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      showPrice: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      showPriceRange: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      productStatusSet: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      showSku: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      showPts: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      showPSV: {
        type: Boolean,
        value: false,
        reflectToAttribute: true,
        notify: true
      },
      showRemove: {
        type: Boolean,
        value: false,
        reflectToAttribute: true,
        observer: '_updateRemove'
      },
      showShadow: {
        type: Boolean,
        value: true,
        reflectToAttribute: true
      },
      hideAction: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      //Vars generated/used internally
      displayPSV: {
        type: String,
        value: ""
      },
      notAvailable: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      backOrdered: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      darkLabel: {
        type: Boolean
      },
      baseSku: {
        type: Boolean,
        reflectToAttribute: true
      },
      showVariantSelect: {
        type: Boolean,
        reflectToAttribute: true
      },
      showPriceLabels: {
        type: Boolean,
        reflectToAttribute: true
      },
      isFavorite: {
        type: Boolean,
        value: false
      },
      qty: {
        type: Number,
        value: 1,
        notify: true
      },
      displayPrice: {
        type: Number
      },
      featuredBundle: {
        type: Boolean
      },
      showEventPrice: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      showEventViolator: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      isMobile: {
        type: Boolean,
        value: false,
        reflectToAttribute: true,
        notify: true
      },
      selectedVariantSku: {
        type: String,
        notify: true
      },
      isVariant: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      modalTitle: {
        type: String
      },
      // This is not intended to be used externally
      product: {
        type: Object
      },
      displayImage: {
        type: String,
        notify: true
      },
      displayAltText: {
        type: String,
        notify: true
      },
      displayTitle: {
        type: String,
        notify: true
      },
      qtyState: {
        type: String,
        value: "blur",
        notify: true,
        reflectToAttribute: true,
        observer: '_qtyState'
      },
      checkoutContinue: {
        type: Boolean,
        value: false
      },
      forMySitePreview: {
        type: Boolean
      },
      fallbackSrc: String,
      // hardcodes price type
      setPriceType: {
        type: 'String',
        observer: '_handlePriceTypeChange'
      },
      forceAdr: {
        type: Boolean
      },
      isEquinoxEnabled: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      eqConfig: {
        type: Object,
        value: {},
        reflectToAttribute: true
      }
    };
  }

  async ready() {
    super.ready();

    // wait for needed configuration to be loaded. This is not just for ns-product-small
    // but what is needed for calls down in ns-shop for instance
    this.CSConfiguration = await this._getConfiguration();

    //init equinox configuration
    this.eqConfig = this.CSConfiguration.Equinox_Markets;
    this.isEquinoxEnabled = equinoxLocalStorage.isEquinoxEnabled() && this.CSConfiguration.Equinox_Markets.active;

    this._initProductStatusListeners();

    if (!this.isEquinoxEnabled) {
      this._initSalesEventListeners();
    }

    if (this.editQty) {
      this.showQty = true;
    }


    this._getCommonStrings();

    this.marketPath = "nuskin";
    if (RunConfigService.getRunConfig().country === 'JP') {
      this.marketPath = "markets";
    }

    if (!!this.translations) {
      this.modalTitle = this.translations.quickShop;
    }

    this._handleFavoritesIcon();
    events.subscribe(events.shop.ADD_TO_FAVORITES_LIST, () => {
      this._handleFavoritesIcon()
    });

    if (util.MobileUtils.isMobile()) {
      this.$.cardAction.opened = true;
      this.showShadow = false;
      this.isMobile = true;
    }

    this.$.variantDropdown.addEventListener('nsDropdownSelect', e => {
      this.variantSelected(e);
    });
    this.notAvailable = false;
    this.backOrdered = false;

    // Get product status manually as race conditions on events.subscribe were causing bugs.
    if (this.sku && !this.isEquinoxEnabled) {
      const results = await ProductStatusService.getProductStatus(this.sku);
      this.processStatusResult(this, results);
    }
  }

  async _getConfiguration() {
    return await getConfiguration(['Cart', 'Basic', 'Url', 'Shopping', 'ADP', 'Equinox_Markets']);
  }

  connectedCallback() {
    super.connectedCallback();
  }

  formatCurrency(price) {
    return CurrencyService.format(price, this.country, this.language);
  }

  addToCart(e) {
    let productToCart = {}
    const productJson = this.product.toJSON()
    if (productJson.sku.substring(2, 4) === "55") {
      productToCart = (this.sku !== productJson.sku) ? this.product.getVariant(this.sku) : this.product;
    } else {
      productToCart = this.selectedVariantSku ? this.product.getVariant(this.selectedVariantSku) : this.product
    }
    //let product = this.selectedVariantSku ? this.product.getVariant(this.selectedVariantSku) : this.product
    const isEquinoxEnabled = equinoxLocalStorage.isEquinoxEnabled() && this.CSConfiguration.Equinox_Markets.active;
    if (isEquinoxEnabled) {
      productToCart.setEquinoxProductId(productJson.equinoxProductId)
    }
    let adr = (this.forceAdr && productToCart.hasAdrOption()) || (productToCart.isAdrOnly() && !AdrService.isAdrOverride())
    let options = {
      sku: (this.displaySku !== productToCart.sku) ? this.displaySku : productToCart.sku,
      qty: this.qty,
      adr: adr,
      product: new Product(productToCart.toJSON()),
      referrer: "productCard",
      domain: window.location.hostname
    };


    if (isEquinoxEnabled) {
      EquinoxCartService.addProductToEquinoxCart(options).then(() => {
        events.publish(events.shop.ADD_TO_CART, options);
        events.publish(events.shop.SHOW_ADD_TO_BAG);
      }).catch(err => {
        // TODO
        console.error(err.response.data);
      });
    } else {
      this.addProductToCart(options);
    }
  }

  addProductToCart(options) {
    CartService.addProductToCart(options).then(() => {
      events.publish(events.shop.ADD_TO_CART, options);
      if (this.checkoutContinue) {
        events.publish(events.shop.SHOW_ADD_TO_BAG, "checkout-continue");
      } else {
        events.publish(events.shop.SHOW_ADD_TO_BAG);
      }
    })
      .catch(err => {
        // TODO
        console.error(err);
      });
  }

  computeCost(price, qty) {
    return price * qty;
  }

  displayRemove(showRemove) {
    if (showRemove) {
      return true;
    }
  }

  _handlePriceTypeChange(priceType) {

    this.priceType = priceType;

    if (this.product) {
      this.product.setPriceAndPvFromType(this._getPriceType(), this.activeSalesEvents);
      this.product = new Product(this.product.toJSON());
      this._productChanged(this.product);
    }
  }

  _handleFavoritesIcon() {

    if (UserService.isLoggedIn()) {
      let searchResultsData = localStorage.getItem(SEARCH_TERM_KEY);
      if (searchResultsData) searchResultsData = JSON.parse(searchResultsData);

      if (searchResultsData && searchResultsData.pendingFavorite && searchResultsData.pendingFavorite === this.displaySku) {
        FavoritesService.addToFavorites(searchResultsData.pendingFavorite).then((favorite) => {
          this.$['favoriteIcon'].classList.add('fill-dark');
          delete searchResultsData.pendingFavorite;
          localStorage.setItem(SEARCH_TERM_KEY, JSON.stringify(searchResultsData));
        }).catch((error) => {
          console.log('Error adding to favorites: ', error);
        });
      } else {
        FavoritesService.isInFavorites(this.displaySku).then((isFavorite) => {
          if (isFavorite) {
            this.$['favoriteIcon'].classList.add('fill-dark');
          } else {
            this.$['favoriteIcon'].classList.remove('fill-dark');
          }
          this.isFavorite = isFavorite;
        }).catch((error) => {
          this.$['favoriteIcon'].classList.remove('fill-dark');
          this.isFavorite = false;
        });
      }
    }
  }

  favoriteItem() {
    if (UserService.isLoggedIn()) {
      if (this.isFavorite) {
        FavoritesService.removeFromFavorites(this.displaySku).then((favorite) => {
          this.$['favoriteIcon'].classList.remove('fill-dark');
          this.isFavorite = !this.isFavorite;
        }).catch((error) => {
          console.error("Error removing from favorites: ", error)
        });
      } else {
        FavoritesService.addToFavorites(this.displaySku).then((favorites) => {
          this.$['favoriteIcon'].classList.add('fill-dark');
          this.isFavorite = !this.isFavorite;
        }).catch((error) => {
          console.error("Error adding to favorites: ", error)
        });
      }
    } else {
      let searchResultsData = localStorage.getItem(SEARCH_TERM_KEY);
      if (searchResultsData) {
        searchResultsData = JSON.parse(searchResultsData);
        searchResultsData.pendingFavorite = this.displaySku;
      } else {
        searchResultsData = {
          pendingFavorite: this.displaySku
        };
      }
      localStorage.setItem(SEARCH_TERM_KEY, JSON.stringify(searchResultsData));
      events.publish(events.authentication.REQUEST_FOR_LOGIN);
    }

  }

  goToProductDetail() {
    if (this.product.equinox.sku.exists === false) {
      return;
    }

    if (window.location.href.indexOf("nssearch") > -1) SitesSessionStorageService.writeItem(KEY_BREADCRUMB_BACK, true);
    let self = this;
    if (window.dataLayer && window.ga && ga.loaded) {
      let impression = {
        event: events.shop.PRODUCT_IMPRESSION_CLICK,
        ecommerce: {
          click: {
            actionField: {},
            products: [{
              name: this.product.title,
              id: this.product.sku,
              price: this.product.price,
              catalog: window.location.pathname.split('/').pop().split('.')[0],
              position: 1,
              domain: window.location.hostname
            }]
          }
        },
        eventCallback: () => { window.location = self.href }   //This should redirect when the datalayer push is done
      };
      dataLayer.push(impression);
    } else {
      window.location = this.href;
    }
  }

  getDarkLabel() {
    if (this.darkLabel !== undefined) {
      return "dark-label";
    }
  }

  //This function processes product data passed in as an attribute
  async _handleInputProductData() {
    if (this.productData) {
      await this._getConfiguration(); // may get called before ready() loads config.
      const isEquinoxEnabled = this.isEquinoxEnabled || this.__data.isEquinoxEnabled;

      if (!this.product || (this.productData.sku !== this.product.sku)) {
        // If the sku changed then create a new product object
        this._reset();
        this.product = new Product(this.productData);

        //pass option for isEquinoxEnabled since this._productChanged not working properly
        //if it is coming from InputProductData observer
        this.product.addPricingFromStatus(this.product, this._getPriceType(), { isEqPromotion: isEquinoxEnabled });
        this.product.setPriceAndPvFromType(this._getPriceType(), this.activeSalesEvents, { isEqPromotion: isEquinoxEnabled });
        this._productChanged(this.product, { isEquinoxEnabled: isEquinoxEnabled });

      } else {
        this.product.setPriceAndPvFromType(this._getPriceType(), this.activeSalesEvents, { isEqPromotion: isEquinoxEnabled });
        this.product.setProductData(this.productData);
      }

      this.displaySku = this.productData.sku;

      //bypass product status service
      if (this.product.isBase()) {
        Object.values(this.product.variants).forEach((variant) => {
          events.publish(events.shop.ADD_SKU_PRODUCT_STATUS_QUEUE, variant.sku);
        });
      } else {
        events.publish(events.shop.ADD_SKU_PRODUCT_STATUS_QUEUE, this.product.sku);
      }

      // this.product.setPriceAndPvFromType(this._getPriceType(), null, { isEqPromotion: isEquinoxEnabled });

      if (!this.productData.fullImage) {
        let productImagePlaceholder = this.shadowRoot.querySelector("#product-image-container");
        // productImagePlaceholder.style.backgroundImage = "url(" + productPlaceholder + ")";
      } else {
        this.productData.fullImage = this.productData.fullImage.replace(/ /g, "%20");
      }

      this._setHref();
      this._handleFavoritesIcon();
      events.publish('nsProductSmallImpressionData', { detail: this.__data });
    }
  }


  //This function handles the returned data when the component is given a SKU, and not a product object.
  handleResponse(data) {
    if (data) {
      if (this.isEquinoxEnabled) {
        this.product = data
        this.product.setPriceAndPvFromType(this._getPriceType(), this.activeSalesEvents, { isEqPromotion: this.isEquinoxEnabled });
      } else {
        this.product.setProductData(data);
        this.product.setPriceAndPvFromType(this._getPriceType(), this.activeSalesEvents, { isEqPromotion: this.isEquinoxEnabled });
        this.product = new Product(this.product.toJSON());
      }

      this._productChanged(this.product);

      if (!this.product.fullImage) {
        let productImagePlaceholder = this.shadowRoot.querySelector("#product-image-container");
        // productImagePlaceholder.style.backgroundImage = "url(" + productPlaceholder + ")";
      } else {
        this.product.fullImage.replace(/ /g, "%20")
      }

      if (this.product.isBase()) {
        this.product.variantSkus().forEach((variantSku) => {
          events.publish(events.shop.ADD_SKU_PRODUCT_STATUS_QUEUE, variantSku);
        });
      }

      this._setHref();
      events.publish('nsProductSmallImpressionData', { detail: this.__data });
    }
  }

  _processTheme(theme) {
    theme = theme.toLowerCase();

    if (theme === "featured" || theme === "popular") {
      this.showSku = false;
      this.showPts = false;
      this.showFavorite = false;
      this.fullCardLink = true;
      this.showViolator = false;
      this.showShadow = false;
      this.hideAction = true;
    } else if (theme === "product-bundle") {
      this.showSku = true;
      this.showQty = false;
      this.editQty = false;
      this.$.cardAction.opened = true;
      this.showViolator = false;
      this.showShadow = false;
      this.showVariantSelect = false;
    } else if (theme === "default") {
      this.showFavorite = true;
      this.showPurchase = true;
      this.editQty = true;
      this.fullCardLink = true;
      this.showPts = false;
      this.showViolator = false;
      this.showShadow = true;
    } else if (theme === "storefront-featured") {
      this.showSku = true;
      this.showFavorite = false;
      this.showPurchase = true;
      this.editQty = true;
      this.fullCardLink = true;
      this.showPts = false;
      this.showViolator = false;
      this.showShadow = true;
      this.showVariantSelect = false;
    }
  }

  _qtyChanged(newValue, oldValue) {
    // If this.qty becomes undefined, then assign oldValue to this.qty
    if (!this.qty && oldValue) {
      this.qty = oldValue;
    }
  }

  _qtyState(newValue, oldValue) {
    this.qtyState = newValue;
  }

  _updateVariantItems() {
    this.variants = [];
    let cartItems = CartService.getItemData();
    cartItems.forEach(item => {
      let sku = item.sku;
      if (this.product.variants[sku]) {
        let variantObj = {
          title: item.title,
          sku: sku,
          qty: item.qty,
          price: item.price
        };
        if (this.product.variants[sku]) {
          variantObj.shade = this.product.variants[sku].shade;
        }
        this.push('variants', variantObj);
      }
    });
  }

  _getPriceType() {
    const user = UserService.getUser();
    this.showPSV = !this.forMySitePreview && !!user && !!user.isDistributor();
    if (UserService.isLoggedIn() && !this.forMySitePreview) {
      return (user.isDistributor() || user.isPreferredCustomer()) ? PriceType.WWHL : PriceType.WRTL
    } else {
      const storeFrontData = JSON.parse(window.sessionStorage.getItem('storefront'))
      const userName = Object.keys(storeFrontData.storefront)[0]
      const market = RunConfigService.getRunConfig().country
      const currentLang = RunConfigService.getRunConfig().language
      //does language entry exists
      const existingLang = storeFrontData.storefront[userName] && 
      storeFrontData.storefront[userName][market] && 
      storeFrontData.storefront[userName][market].lang && 
      storeFrontData.storefront[userName][market].lang[currentLang] 
      ? currentLang 
      : 'en';
      const existingMarket =  storeFrontData.storefront[userName][market] ? market : 'US'
      const isMySiteWholesale = storeFrontData.storefront[userName][existingMarket].lang[existingLang] ? storeFrontData.storefront[userName][existingMarket].lang[existingLang].wholesale : false 
      return isMySiteWholesale ? PriceType.WWHL : PriceType.WRTL
    }
  }

  isVariantSelected() {
    return !!this.selectedVariantSku;
  }

  variantSelected(e) {
    this.selectedVariantSku = e.detail.selectedItem.value;
    this.displaySku = this.selectedVariantSku;
    this.product = new Product(this.product.toJSON());
    this._productChanged(this.product);
    this.isVariant = true;

    //Persist the selected variant to the UPDP
    let variantStorageObj = {};
    variantStorageObj[this.product.sku] = this.selectedVariantSku;
    let varObjString = JSON.stringify(variantStorageObj);
    localStorage.setItem(PRODUCT_SMALL_VARIANT, varObjString);
    events.publish(events.shop.VARIANT_CHANGED, this.product.sku);
  }

  listboxVariantSelected(e) {
    this.$.cardModal.close();
    this.$.cardModalOverlay.hide();
    this.sku = e.detail.item.dataset.value;
  }

  _setHref() {
    if (this.pdpurl) {
      this.href = this.pdpurl;
    } else {
      this.href = util.getLocaleUrl() + "products/product." + this.displaySku + ".html";
    }
  }

  /**
   * @todo dumb components should not contain HTTP any request.
   * @todo move this to the parent component that uses this—possible breaking change and tons of rework.
   * @param {*} newValue
   * @param {*} oldValue
   * @memberof NsProductSmall
   */
  async _skuUpdate(newValue, oldValue) {

    // hides product on sku change untill new one gets loaded to avoid `choppy` visual behavior on my-site-preview
    this.$.productSmallContainer.className += ' hidden';
    if (newValue && newValue.length === 8 && newValue !== oldValue) {
      await this._getConfiguration(); // this can get called before ready() loads config
      this._reset();
      this.displaySku = this.sku;
      this.product = new Product({ sku: this.displaySku });
      this.product.setPriceAndPvFromType(this._getPriceType(), this.activeSalesEvents, { isEqPromotion: this.isEquinoxEnabled });
      this._productChanged(this.product);
      if (!this.product.isBase()) {
        events.publish(events.shop.ADD_SKU_PRODUCT_STATUS_QUEUE, this.displaySku);
      }

      if (!nuskin.hasOwnProperty("configuration")) {
        events.subscribe(events.global.CONFIGURATION_SET, async () => {
          const data = await ProductDataService.getProductData(this.sku);
          if (data.products.length > 0) {
            this.handleResponse(data.products[0]);
          }
        });
      } else {
        const data = await ProductDataService.getProductData(this.sku);
        if (data.products.length > 0) {
          this.handleResponse(data.products[0]);
        }
      }


      if (!this.showPurchase) {
        if (this.qty < 1) {
          this.qty = 1;
        }
      }
    }
  }



  // placeholder function for any cleanup that is necessary when the sku or product data changes
  _reset() {
    this.productStatusSet = false;
  }

  _updateRemove() {
    this.displayRemove()
  }

  toggleAction() {
    if (!this.featuredBundle && !util.MobileUtils.isMobile() && !this.hideAction) {
      this.$.cardAction.toggle();
    }
  }

  openAction() {
    if (!util.MobileUtils.isMobile() && !this.hideAction) {
      this.$.cardAction.show();
    }
  }

  closeAction() {
    if (!util.MobileUtils.isMobile() && !this.hideAction) {
      this.$.cardAction.hide();
    }
  }

  openModal() {
    this.dispatchEvent(new CustomEvent('reset-event', { detail: { value: true } }));
    this.$.cardModal.open();
    this.$.cardModalOverlay.show();
  }

  closeModal() {
    this.dispatchEvent(new CustomEvent('reset-event', { detail: { value: false } }));
    this.$.cardModal.close();
    this.$.cardModalOverlay.hide();
  }

  _getUserType() {
    let userType = "";
    if (UserService.isLoggedIn()) {
      let user = UserService.getUser();
      userType = user.accountType;
    }

    return userType;
  }

  /**
     * Pass in array of objects and set the proper string for PSV label displayed to user
     * @param {array} strings
     */
  _setStrings(strings) {
    let userType = this._getUserType();

    switch (userType) {
      case "10":
        this.psvLabel = strings.psvDist;
        break;
      case "20":
        this.psvLabel = strings.psvCust;
        break;
      case "30":
        this.psvLabel = strings.psvPfc;
        break;
      default:
        this.psvLabel = strings.psvAnon;
        break;
    }
    this.backOrderedLbl = strings.backOrdered;
    this.outOfStockLbl = strings.outOfStock;
    this.discontinued = strings.discontinued;
    this.itemLbl = strings.item;
    this.purchaseLbl = strings.addToCart;
    this.addToAdrLbl = strings.addToAdr;
    this.selectLbl = strings.select;
    this.modalTitle = this.quickShopLbl = strings.quickShop;
    this.adrPriceLabel = strings.adrPriceLabel;
    this.retailPriceLabel = strings.retailPriceLabel;
    this.wholesalePriceLabel = strings.wholesalePriceLabel;
    this.salesEventPriceLabel = strings.salesEventPriceLabel;
  }

  /**
     * Define an array of objects to get common labels
     */
  _getCommonStrings() {
    let inheritedStrings = [
      { key: "psvDist", dflt: "" },
      { key: "psvCust", dflt: "" },
      { key: "psvPfc", dflt: "" },
      { key: "psvAnon", dflt: "" },
      { key: 'backOrdered', dflt: 'Your product(s) will ship by:' },
      { key: 'outOfStock', dflt: 'Out of stock' },
      { key: 'discontinued', dflt: 'Product is not available' },
      { key: 'item', dflt: 'Item' },
      { key: 'addToCart', dflt: 'ADD TO BAG' },
      { key: 'addToAdr', dflt: 'Add to Subscription' },
      { key: 'select', dflt: 'Select' },
      { key: 'quickShop', dflt: 'Quick Shop' },
      { key: "adrPriceLabel", dflt: "ADR Price" },
      { key: "retailPriceLabel", dflt: "Retail Price" },
      { key: "wholesalePriceLabel", dflt: "Wholesale Price" },
      { key: "salesEventPriceLabel", dflt: "Sale Price" }
    ];

    StringService.getStrings(inheritedStrings).then(strings => {
      this._setStrings(strings);
    });
  }

  _hasVariants() {
    return this.product && this.product.variants && this.product.variants.length > 0;
  }

  _setPriceData(product, option) {

    let isEquinoxEnabled = this.isEquinoxEnabled || option && option.isEquinoxEnabled;
    const isGrapQLActive =   (this.eqConfig && this.eqConfig.MySite_graphql_active
      || (option && option.isGrapQLActive));

    let isBaseSku = false;
    if (isEquinoxEnabled) {
      if (this.eqConfig.active) {
        this.showVariantSelect = (Object.keys(product.variants).length > 1) ? true : false;
      } else {
        this.showVariantSelect = product.isBase();
      }
    } else {
      this.showVariantSelect = isBaseSku = (product.isBase() && this.sku === product.sku) ? true : false;
    }

    this.showPriceRange = this.showPvRange = isBaseSku = (product.isBase() && this.sku === product.sku) ? true : false;;

    const marketConfig = ConfigService.getMarketConfig();
    const user = UserService.getUser();

    product.setPriceAndPvFromType(this._getPriceType(), this.activeSalesEvents, { isEqPromotion: isEquinoxEnabled });
    const isSale = !!product.eventName || !!product.savedEventName;

    this.price = product.getPrice();
    if (isEquinoxEnabled && isSale) {
      this.price = product.getPricing(`${product.eventName}-${this._getPriceType()}`);
    }

    const isRetailUser = user !== null && !(user.isDistributor() || user.isPreferredCustomer());
    const isWholeSale = isRetailUser ? false : user !== null || !!marketConfig.showWholeSalePricing

    //get original retail pricing if in graphQL
    let retailPrice = isGrapQLActive ? (product.getPricing(PriceType.RTL) || product.getPricing(PriceType.WRTL)):  product.getPricing(PriceType.WRTL);
    let wholesalePrice = isGrapQLActive ? (product.getPricing(PriceType.WHL) || product.getPricing(PriceType.WWHL)):  product.getPricing(PriceType.WWHL);
    if (this.product.hasAdrOption() && !this.product.hasOrderOption()) {
      retailPrice = isGrapQLActive ? (product.getPricing(PriceType.ADR) || product.getPricing(PriceType.WADR)):  product.getPricing(PriceType.WADR);
      wholesalePrice = isGrapQLActive ? (product.getPricing(PriceType.ADW) || product.getPricing(PriceType.WADW)):  product.getPricing(PriceType.WADW);
      this.price = isWholeSale ? wholesalePrice : retailPrice
    }
    this.pv = (product.pv || 0).toFixed(2);

    const showRetailCrossedOut =
      isWholeSale &&
      !isBaseSku &&
      !isSale &&
      retailPrice > this.price &&
      !!marketConfig.showRetailCrossedOut;
    this.showPriceLabels = !!marketConfig.showPriceLabels;
    this.defaultPriceLabel = isWholeSale ? this.wholesalePriceLabel : this.retailPriceLabel;


    if (showRetailCrossedOut) {
      this.originalPrice = retailPrice;
      this.originalPriceLabel = this.retailPriceLabel;
      this.activePriceLabel = this.wholesalePriceLabel;
      this.showEventViolator = false;
    } else if (isSale) {
      this.originalPrice = isWholeSale || !!marketConfig.showWholeSalePricing ? wholesalePrice : retailPrice
      this.originalPriceLabel = isWholeSale ? this.wholesalePriceLabel : this.retailPriceLabel;
      this.activePriceLabel = this.salesEventPriceLabel;
      this.showEventViolator = true;

      //workaround to hardcoded priceType === PriceType.WRTL in ns-product-lib mapping
      //which makes the PriceType === PriceType.WRTL to render WWHL - WWHL price value
      //for product that has promotion
      //set the price to  WWHL if this._getPriceType() === WRTL
      //promotion price is set in product.js   setPriceAndPvFromType function
      // if ((!isGrapQLActive && isEquinoxEnabled && this._getPriceType() == PriceType.WRTL)) {
      //   this.price = product.getPricing(PriceType.WWHL);
      // }
    }

    this.showEventPrice = (isSale || showRetailCrossedOut);

    //get original wholesale price
    //check if has childSkus, which means  bundle/kit
    // if ((isEquinoxEnabled && isGrapQLActive && this._getPriceType() === PriceType.WWHL)) {
    //   if (product.childSkus && product.childSkus.length) {
    //     this.originalPrice = product.getPricing(PriceType.WHL);
    //   }
    // }

    if (isGrapQLActive && isSale) {
      this.showEventPrice = this.originalPrice > this.price;
    }

    this.showPrice = !(this.showPriceRange || this.showEventPrice);

    if (this.showPriceRange) {
      this.minPrice = product.getMinPrice();
      this.maxPrice = product.getMaxPrice();
      if (this.minPrice === this.maxPrice) {
        this.showPriceRange = false;
        this.showPrice = true;
        this.price = this.minPrice;
      }
    }

    if (this.showPvRange) {
      this.minPv = (product.getMinPv() || 0).toFixed(2);
      this.maxPv = (product.getMaxPv() || 0).toFixed(2);
      if (this.minPv === this.maxPv) {
        this.showPvRange = false;
        this.pv = this.minPv;
      }
    }

    this.dispatchEvent(new CustomEvent('price-updated', {
      bubbles: true,
      composed: true,
      detail: {
        price: this.price
      }
    }));
  }

  _setStatusFlags(product) {
    this.purchasable = true;
    this.notAvailable = false;
    this.backOrdered = false;
    this.backOrderDate = '';
    this.maxQuantity = Math.min(product.maxQuantity, product.availableQuantity);

    if (product.status === 'RELEASED_FOR_SALE') {
      let runConfig = RunConfigService.getRunConfig();
      const locale = `${runConfig.language}_${runConfig.country}`;

      if (product.backOrderDate) {
        this.maxQuantity = Math.max(product.maxQuantity, product.availableQuantity);
        //there are some cases that Backordered product has availableQuantity  === 0
        if (this.maxQuantity < this.qty) {
          this.purchasable = false;
          this.notAvailable = true;
        } else {
          if (Date.parse(product.backOrderDate) > Date.parse(new Date())) {
            this.backOrdered = true;
            product.inventory = 'BACKORDER'
            product.properties.isBackOrdered = true;
            product.properties.inventoryStatus = "BACKORDER";
            this.backOrderDate = dateFormatter.getCountryFormattedDate(
              product.backOrderDate,
              locale
            );
            this.purchasable = true;
          } else {
            if (product.availableQuantity > 0) {
              this.maxQuantity = product.availableQuantity;
              this.purchasable = true;
            } else {
              this.purchasable = false;
              this.notAvailable = true;
            }
          }
        }
      } else if (product.availableQuantity < this.qty) {
        this.purchasable = false;
        this.notAvailable = true;
      } else {
        if (this.showPurchase) {
          this.purchasable = true;
        }
      }
    } else if (product.status && product.status.length > 0) {
      this.notAvailable = true;
      this.purchasable = false;
    } else if (product.isBase()) {
      this.purchasable = false;
    }
  }

  async _productChanged(newVal, option) {

    if ((Object.keys(this.eqConfig)).length === 0) {

      this.CSConfiguration = await this._getConfiguration();

      //init equinox configuration
      this.eqConfig = this.CSConfiguration.Equinox_Markets;
      this.isEquinoxEnabled = equinoxLocalStorage.isEquinoxEnabled()
      && this.CSConfiguration.Equinox_Markets.active;
    }

    const isEquinoxEnabled = (this.isEquinoxEnabled) || (option && option.isEquinoxEnabled);
    const isGrapQLActive =   this.eqConfig && this.eqConfig.MySite_graphql_active;

    // Fades product in when its price becomes available.
    // this is done to avoid `choppy` visual behavior on my-site-preview, when user edits featured products' order
    let isBaseSkuWithPrice;
    let variantsSkus = newVal && newVal.variants
      ? Object.keys(newVal.variants)
      : [];
    if (variantsSkus) {
      isBaseSkuWithPrice = !!(newVal.variants[variantsSkus[0]] && newVal.variants[variantsSkus[0]].price);
    }

    if (newVal && newVal.price || isBaseSkuWithPrice || newVal.status !== undefined) {
      this.$.productSmallContainer.className = this.$.productSmallContainer.className.split(' hidden').join('');
      document.dispatchEvent(new CustomEvent('ns-product-small-updated-skus'), { bubbles: true, composed: true });
    }
    let variant = {}
    if (this.product.isBase()) {
      variant = this.sku !== this.product.sku ? this.product.getVariant(this.sku) : null;
    } else {
      variant = this.selectedVariantSku ? this.product.getVariant(this.selectedVariantSku) : null;
    }
    if (isEquinoxEnabled && Object.keys(this.product.variants) > 1 && !this.selectedVariantSku) {
      variant = this.selectedVariantSku ? this.product.variants.filter(p => p.default === true) : null;
    }
    //check variant if basesku
    let product = variant ? variant : this.product;

    this.displayImage = product.fullImage ? product.fullImage : null;
    this.displayAltText = product.getImageAltText();

    this.displayTitle = product.title;


    this._setStatusFlags(product);
    this._setPriceData(product, { isEquinoxEnabled: isEquinoxEnabled, isGrapQLActive: isGrapQLActive });

    //set add to cart label
    if ((this.forceAdr && product.hasAdrOption()) || (product.isAdrOnly() && !AdrService.isAdrOverride())) {
      this.purchaseLbl = this.addToAdrLbl;
    }

    if (isEquinoxEnabled) {
      //Update variants and basesku but do not rely on isBase function anymore
      if (Object.keys(this.product.variants).length > 1) {
        this.showVariantSelect = (this.theme === "product-bundle" || this.theme === "storefront-featured") ? false : true;
        this.variantsList = Object.values(this.product.variants);
        this.$.variantDropdown.initSelection = 0;
        this._updateVariantItems();
      } else {
        this.baseSku = false;
        this.showVariantSelect = false;
        this.variantsList = null;
        this.selectedVariantSku = null;
      }
    } else {
      if (this.product.isBase() && this.product.sku === this.sku) {
        this.baseSku = true;
        this.showVariantSelect = true;
        this.variantsList = Object.values(this.product.variants);
        this.$.variantDropdown.initSelection = 0;
        this._updateVariantItems();
      } else if (this.product.isBase() && this.product.sku !== this.sku) {
        this.baseSku = false;
        this.showVariantSelect = false;
        this.variantsList = null;
        this.selectedVariantSku = null;
      } else {
        this.baseSku = false;
        this.showVariantSelect = false;
        this.variantsList = null;
        this.selectedVariantSku = null;
      }
    }

  }

  _initProductStatusListeners() {
    let scope = this;

    events.subscribe(events.authentication.LOGIN, function () {
      if (scope.product) {
        scope.product.setPriceAndPvFromType(scope._getPriceType(), scope.activeSalesEvents);
        scope.product = new Product(scope.product.toJSON());
        scope._productChanged(scope.product);
      }
    });

    events.subscribe(events.authentication.LOGOUT, function () {
      if (scope.product) {
        scope.product.setPriceAndPvFromType(scope._getPriceType(), scope.activeSalesEvents);
        scope.product = new Product(scope.product.toJSON());
        scope._productChanged(scope.product);
      }
    });

    events.subscribe(events.shop.PRODUCT_STATUS_RESULT, results => {
      this.processStatusResult(scope, results);
    });
  }

  processStatusResult(scope, results) {

    // by pass product status service process status result
    //@since this is just a workaround to make eq market work without disabling the  product status service
    //@todo  do final solution to support  product status service for equinox market
    results.forEach(skuStatusResult => {

      const isEquinoxEnabled = this.eqConfig.active && this.isEquinoxEnabled;

      let productStatus = skuStatusResult;
      if (isEquinoxEnabled) {
        productStatus = scope.product;
      }

      const isPricingFromStatus = scope.product && scope.product.addPricingFromStatus(productStatus, scope._getPriceType(), { isEqPromotion: isEquinoxEnabled });

      if (isPricingFromStatus) {
        scope.product.setMarketAttributes(productStatus);
        scope.product = new Product(scope.product.toJSON());

        //update price immediately instead of relying on _processActiveEvents (INC0045799)
        scope.product.setPriceAndPvFromType(scope._getPriceType(), scope.activeSalesEvents, { isEqPromotion: isEquinoxEnabled });
        scope._productChanged(scope.product);
        if (scope.productData) {
          scope.productData.priceMap = scope.product.priceMap;
          scope.productData.pvMap = scope.product.pvMap;
          scope.productData.cvMap = scope.product.cvMap;
        }
        scope.productStatusSet = true;
      }
    });

  }

  _initSalesEventListeners() {
    events.getValue(events.salesevent.ACTIVE_EVENTS, this._processActiveEvents(this), true);
    events.publish(events.salesevent.POLL_MARKET_CONFIG);
  }

  _processActiveEvents(_scope) {
    let scope = _scope;

    const isEquinoxEnabled = equinoxLocalStorage.isEquinoxEnabled() && this.CSConfiguration.Equinox_Markets.active;

    return (activeEvents) => {
      if (Array.isArray(activeEvents) && activeEvents.length > 0 && scope.product) {

        //bypass active events in legacy if eq market enabled
        if (isEquinoxEnabled) {
          scope.product = new Product(scope.product.toJSON());
          scope.product.setPriceAndPvFromType(scope._getPriceType(), scope.activeSalesEvents, { isEqPromotion: isEquinoxEnabled });
          scope._productChanged(scope.product);
          return;
        }

        let origEventName = scope.product.eventName
        scope.product.setPriceAndPvFromType(scope._getPriceType(), activeEvents, { isEqPromotion: isEquinoxEnabled });
        if (activeEvents && Array.isArray(activeEvents) && scope.product) {
          this.activeSalesEvents = activeEvents;
        }

        if (origEventName !== scope.product.eventName) {
          scope.product = new Product(scope.product.toJSON());
          scope._productChanged(scope.product);
        }
      }
    }
  }

  isDiscontinued(status) {
    return status === "DISCONTINUED";
  }
}

customElements.define(NsProductSmall.is, NsProductSmall);
